import "./polyfill.DatePickerRangeController";

export { default } from "react-dates/lib/components/DayPickerRangeController";

require("./DayPickerRangeController.less");